import { Routes } from '@angular/router';
import { loginRoutes } from '@softapps/allgemein/login';
import { settingsRoutes } from '@softapps/allgemein/utils';
import { passwordRoutes } from '@softapps/allgemein/password';
import { moduleRoutes } from '@softapps/allgemein/modules';
import { bestellvorschlagRoutes } from '@softapps/mde/bestellvorschlag';
import { bestellerfassungRoutes } from '@softapps/mde/bestellerfassung';
import { etikettendruckRoutes } from '@softapps/mde/etikettendruck';
import { retourenRoutes } from '@softapps/mde/retouren';
import { warenverprobungRoutes } from '@softapps/mde/warenverprobung';
import { artikelInfoRoutes } from '@softapps/wws/artikel-info';
import { materiallieferscheinScanRoutes } from '@softapps/mde/materiallieferschein-scan';
import { energietransportRoutes } from '@softapps/wws/energietransport';
import { eslLinkRoutes } from '@softapps/handel/esl-link';
import { gesamtabfrageRoutes } from '@softapps/wws/gesamtabfrage';
import { mdeInventoryRoutes } from '../../../../../../libs/softapps/mde/inventory/src/lib/inventory.routes';
import { lieferscheinRoutes } from '@softapps/wws/lieferschein';
import { stempelerfassungRoutes } from '@softapps/pms/stempelerfassung';
import { arbeitsberichtRoutes } from '@softapps/gewerbe/arbeitsbericht';

export const shellRoutes: Routes = [
  //Allgemein
  ...moduleRoutes,
  ...settingsRoutes,

  //Wws
  // ...gesamtabfrageRoutes,
  // ...stempelerfassungRoutes

  // MDE
  ...bestellvorschlagRoutes,
  ...bestellerfassungRoutes,
  ...etikettendruckRoutes,
  ...mdeInventoryRoutes,
  ...retourenRoutes,
  ...warenverprobungRoutes,
  ...materiallieferscheinScanRoutes,
  ...artikelInfoRoutes,
  ...eslLinkRoutes,

  ...energietransportRoutes,
  ...gesamtabfrageRoutes,

  ...lieferscheinRoutes,
  ...stempelerfassungRoutes,
  ...arbeitsberichtRoutes,
];

export const publicRoutes: Routes = [
  ...loginRoutes,
  ...passwordRoutes,
  ...settingsRoutes,
];

/*
export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('@softapps/core').then((o) => o.ShellComponent),
    children: [
      //Allgemein
      ...moduleRoutes,
      ...settingsRoutes,

      //Wws
      // ...gesamtabfrageRoutes,
      // ...stempelerfassungRoutes

      // MDE
      ...bestellvorschlagRoutes,
      ...bestellerfassungRoutes,
      ...etikettendruckRoutes,
      ...lagerInventurRoutes,
      ...retourenRoutes,
      ...warenverprobungRoutes,
      ...materiallieferscheinScanRoutes,
      ...artikelInfoRoutes,
      ...eslLinkRoutes,

      ...energietransportRoutes,
      ...deliveryNoteProcessingRoutes,
      ...gesamtabfrageRoutes,
    ],
    canActivate: [AuthenticationGuard],
  },
  {
    path: '',
    loadComponent: () => import('@softapps/core').then((o) => o.PublicShellComponent),
    children: [...loginRoutes, ...passwordRoutes, ...settingsRoutes],
  },
  {
    path: '**',
    redirectTo: '/',
  },
];
*/
